import { CalculatorInputFieldsType, CalculatorInputFieldsValues, } from '../utils/CalculatorInputValue';
import React, { useState } from 'react';
import { CalculatorPrefixContext } from '../../../shared/contexts/CalculatorContext';
import { CalculatorFieldsContext } from '../contexts/CalculatorContext';
import { calculatorParams } from '../CalculatorParams';
import { CalculatorOutlet } from './CalculatorOutlet';

export function CalculatorParamsOutlet(): JSX.Element {
    const calculatorFieldsState = useState<CalculatorInputFieldsType>(CalculatorInputFieldsValues);
    const calculatorPrefixState = useState<string>(calculatorParams.prefix);

    return (
        <CalculatorPrefixContext.Provider value={calculatorPrefixState}>

            <CalculatorFieldsContext.Provider value={calculatorFieldsState}>

                <CalculatorOutlet/>

            </CalculatorFieldsContext.Provider>

        </CalculatorPrefixContext.Provider>
    );
}
